export default __webpack_public_path__ + "73d1fa70029680a08187c0065f2a550c.png";